import login from './login';

export default {
  language: 'pt-BR',
  country: 'br',
  name: 'Português',
  embeddedLocale: login,
  flags: ['BR', 'PT'],
};
